export enum SearchScreenFocusKeys {
  SearchButton = "SEARCHSCREEN:SEARCHBUTTON",
  SearchInput = "SEARCHPROMPT:SEARCHINPUT",
}
